import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import SizePills from "./size-pills/index";
import { fetchClearanceAvailability, fetchClearancePricing } from "slices/pdp-clearance-slice";
import AddToBagError from "./add-to-bag-error";
import AddToBag from "./add-to-bag/index";
import AtomErrorNotification from "components/source/atoms/atom-error-notification";
import { Faq } from "routes";
import { ASSORTMENTS } from "rtr-constants";

export default function ClearanceBuyBox() {
  const [selectedSize, setSelectedSize] = useState(null);
  const staticProduct = useSelector(state => state.staticProduct);

  /* TODO: Remove hardcoding of depotId when we figure out filtering mechanism based on location */
  const availability = useSelector(state =>
    state.pdp?.clearance?.availability?.response?.items?.filter(o => o.depotId === "52")
  );
  const availabilityLoaded = useSelector(state => state.pdp?.clearance?.availability?.loaded);
  const availabilityError = useSelector(state => state.pdp?.clearance?.availability?.error);
  const categoryRoot = useSelector(state => state.staticProduct?.categoryRoot);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchClearanceAvailability({ productId: staticProduct.productId }));
    dispatch(fetchClearancePricing({ productId: staticProduct.productId }));
  }, []);

  // Assume available until availability has loaded
  const styleUnavailable = availabilityLoaded && !availability?.find(el => el.availableCount > 0);

  return (
    <section data-test-id="clearance-buy-box" aria-labelledby="clearance-add-to-bag">
      <SizePills
        skus={staticProduct.skus}
        availability={availability}
        availabilityLoaded={availabilityLoaded}
        availabilityError={availabilityError}
        onSelect={setSelectedSize}
        hideOneSize={categoryRoot === ASSORTMENTS.WOMENS_ACCESSORIES}
      />

      {styleUnavailable && (
        <AtomErrorNotification
          additionalClassName={"available-soon"}
          errorCopy={"This item will be available soon! Heart it now so you can buy it later."}
          errorCTA={"Learn More"}
          errorURL={Faq.notAvailable}
        />
      )}

      <AddToBagError />

      <AddToBag
        membershipError={null}
        availability={availability}
        availabilityLoaded={availabilityLoaded}
        selectedSize={selectedSize}
        isClearance={true}
      />
    </section>
  );
}
